export const GET_DESTINATIONS_FOR_SLUG_ENDPOINT = '/graphql/execute.json/yme/getDestinationsForSlug;slug=${slug};rootPath=${rootPath}';
export const SLUG_PREFIX = '${slug}';
export const ROOT_PATH_PREFIX = '${rootPath}';
export const GAP_BETWEEN_ITEMS = 16;
